import { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { useTranslation } from 'react-i18next'
import { CustomFile } from '../../../app/models/file'

interface Props {
  setFiles: (file: any) => void
  setImage?: (file: any) => void
  files: CustomFile[]
}

function PhotoWidgetDropzone({ setFiles, setImage, files }: Props) {
  const { t } = useTranslation()
  const dzStyles = {
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: '#000',
    borderRadius: '5px',
    backgroundColor: '#F4F0F0',
    paddingTop: '35px',
    textAlign: 'center' as const,
    height: 100,
    marginBottom: '20px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 5px 20px 0px rgba(0, 0, 0, 0.10)',
  }

  const dzActive = {
    borderColor: 'green',
  }

  const [firstImageAdded, setFirstImageAdded] = useState<boolean>(false)
  const onDrop = useCallback(
    (acceptedFiles: any[]) => {
      const isFirstImage = !firstImageAdded
      setFirstImageAdded(true)

      const imageFiles = acceptedFiles.filter((file: any) => file.type.startsWith('image/'))

      setFiles((prevFiles: CustomFile[]) => [
        ...prevFiles,
        ...imageFiles.map((file: any, index: number) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            primary: isFirstImage && files.length === 0 && index === 0,
          }),
        ),
      ])

      if (setImage) {
        setImage((prevImages: any[]) => [
          ...prevImages,
          ...acceptedFiles.map((file: any, index: number) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
              primary: isFirstImage && files.length === 0 && index === 0,
            }),
          ),
        ])
      }
    },
    [firstImageAdded, setFiles, setImage, files.length],
  )
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpg': [],
      'image/jpeg': [],
      'image/png': [],
      'image/pjpeg': [],
      'image/bmp': [],
      'image/webp': [],
      'image/tiff': [],
      'image/tif': [],
      'image/svg+xml': [],
      'image/heic': [],
      'image/heif': [],
      'image/vnd.microsoft.icon': [],
      'image/x-raw': [],
      'image/x-xbitmap': [],
      'image/x-xbm': [],
      'image/avif': [],
    },
  })
  return (
    <div
      className='bg-white'
      {...getRootProps()}
      style={isDragActive ? { ...dzStyles, ...dzActive } : dzStyles}
    >
      <input {...getInputProps()} />
      <FileUploadIcon />
      <p style={{ fontSize: '0.85rem' }}>{t('drop_images_here')}</p>
    </div>
  )
}

export default PhotoWidgetDropzone
